// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__Ew9pE","paramInput":"JobSimulator_paramInput__Qj4pS","input":"JobSimulator_input__3tRE1"};